import { Platform } from './platforms'
import { TrialType } from './subscription'

export const STORE_LINKS = {
  [Platform.android]: 'https://tap.prisma-ai.com/2DAg/shc1bqvl',
  [Platform.ios]: 'https://tap.prisma-ai.com/2DAg/shc1bqvl',
}
